var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnchorDownLtr = function SvgAnchorDownLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M36.722 60.048a3 3 0 0 1 4.23-.326L49.5 67.05l8.548-7.327a3 3 0 0 1 3.904 4.556l-10.5 9a3 3 0 0 1-3.904 0l-10.5-9a3 3 0 0 1-.326-4.23",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 36.5C21 20.76 33.76 8 49.5 8S78 20.76 78 36.5v27C78 79.24 65.24 92 49.5 92S21 79.24 21 63.5zM49.5 14C37.074 14 27 24.074 27 36.5v27C27 75.926 37.074 86 49.5 86S72 75.926 72 63.5v-27C72 24.074 61.926 14 49.5 14",
    clipRule: "evenodd"
  })));
};
export default SvgAnchorDownLtr;